<template>
  <v-layout v-if="confirmer.active" row justify-center>
    <v-dialog :value="confirmer.active" persistent max-width="290">
      <v-card>
        <v-card-title class="headline">{{ confirmer.title }}</v-card-title>
        <v-card-text v-if="confirmer.body">{{ confirmer.body }}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey darken-1" text @click.native="cancel">{{ $t('discard') }}</v-btn>
          <v-btn color="primary darken-1" text @click.native="confirm">{{ $t('keep') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
export default {
  name: 'unsaved-dialog',
  computed: {
    confirmer () {
      return this.$store.state.unsavedDialog
    }
  },
  methods: {
    confirm () {
      this.confirmer.resolve(true)
      this.$store.commit('hideUnsavedDialog')
    },
    cancel () {
      this.confirmer.resolve(false)
      this.$store.commit('hideUnsavedDialog')
    }
  }
}
</script>
